import './MovieCard.css';

import * as React from 'react';
import { Link } from 'react-router-dom';
import getLocalUser from 'src/user/getLocalUser';

import { CrewMember } from '../types/Movie';
import { getDayFromNow, getYear, minutesToHours } from '../utils';

interface MovieCardProps {
  movieId: number;
  title: string;
  poster?: string;
  directors?: CrewMember[];
  listMutationsOptimisticResponse: any;
  releaseDate?: string;
  runtime?: number;
  userProfile: any;
  addMovieToList: any;
  deleteMovieFromList: any;
}

class MovieCard extends React.Component<MovieCardProps, {}> {
  public render() {
    const { movieId } = this.props;

    return (
      <div className={"ui card movie-card-container"}>
        <Link to={"/movie/" + this.props.movieId}>
          <div className="body">
            <div className="image poster-container">
              <img
                className={"poster"}
                src={
                  this.props.poster ||
                  "https://popcornusa.s3.amazonaws.com/placeholder-movieimage.png"
                }
              />
            </div>
            <div className="content">
              <Link to={"/movie/" + this.props.movieId}>
                <div className="header movieTitle">
                  {this.props.title}{" "}
                  {this.props.releaseDate &&
                    `(${getYear(this.props.releaseDate)})`}
                </div>
              </Link>
              <div className="meta">
                {this.props.directors &&
                  this.props.directors.map((d, i) => (
                    <span key={i}>{d.name}</span>
                  ))}
                {
                  <span className="runtime">
                    {minutesToHours(this.props.runtime)}
                  </span>
                }
              </div>
            </div>
          </div>
        </Link>
        <div className="extra content footer">
          {this.props.releaseDate && (
            <span className="release-time">
              {getDayFromNow(this.props.releaseDate, "Release", "Released")}{" "}
            </span>
          )}
          {this.props.userProfile && (
            <div
              className="right floated card-actions ui buttons mini"
              onClick={this.cardActionsClickHandler}
            >
              {(this.props.userProfile.followList &&
                this.props.userProfile.followList.items.hasOwnProperty(
                  this.props.movieId
                ) && (
                  <button
                    onClick={this.props.deleteMovieFromList.mutation.bind(
                      this,
                      {
                        optimisticResponse: this.props.listMutationsOptimisticResponse(
                          {
                            movieId,
                            movieListType: "followList",
                            mutationField: "deleteMovieFromList",
                          }
                        ),
                        variables: {
                          movieId,
                          movieListType: "followList",
                          userToken: getLocalUser().token,
                        },
                      }
                    )}
                    className="ui basic toggle active inverted button"
                  >
                    Following
                  </button>
                )) || (
                <button
                  onClick={this.props.addMovieToList.mutation.bind(this, {
                    optimisticResponse: this.props.listMutationsOptimisticResponse(
                      {
                        movieId,
                        movieListType: "followList",
                        mutationField: "addMovieToList",
                      }
                    ),
                    variables: {
                      movieId,
                      movieListType: "followList",
                      userToken: getLocalUser().token,
                    },
                  })}
                  className="ui basic inverted button"
                >
                  Follow
                </button>
              )}

              {(this.props.userProfile.watchList &&
                this.props.userProfile.watchList.items.hasOwnProperty(
                  this.props.movieId
                ) && (
                  <button
                    onClick={this.props.deleteMovieFromList.mutation.bind(
                      this,
                      {
                        optimisticResponse: this.props.listMutationsOptimisticResponse(
                          {
                            movieId,
                            movieListType: "watchList",
                            mutationField: "deleteMovieFromList",
                          }
                        ),
                        variables: {
                          movieId,
                          movieListType: "watchList",
                          userToken: getLocalUser().token,
                        },
                      }
                    )}
                    className="ui basic toggle active inverted button"
                  >
                    Watched
                  </button>
                )) || (
                <button
                  onClick={this.props.addMovieToList.mutation.bind(this, {
                    optimisticResponse: this.props.listMutationsOptimisticResponse(
                      {
                        movieId,
                        movieListType: "watchList",
                        mutationField: "addMovieToList",
                      }
                    ),
                    variables: {
                      movieId,
                      movieListType: "watchList",
                      userToken: getLocalUser().token,
                    },
                  })}
                  className="ui basic inverted button"
                >
                  Watch
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  private cardActionsClickHandler = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
}

export default MovieCard;



// WEBPACK FOOTER //
// ./src/components/MovieCard.tsx